const AUTH_KEYS = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  username: 'username',
};

function getStorage(type) {
  if (typeof window === 'undefined') {
    return null;
  }

  return window[type] ?? null;
}

function migrateLegacyAuthStorage() {
  const sessionStorageRef = getStorage('sessionStorage');
  const localStorageRef = getStorage('localStorage');

  if (!sessionStorageRef || !localStorageRef) {
    return;
  }

  Object.values(AUTH_KEYS).forEach((key) => {
    const sessionValue = sessionStorageRef.getItem(key);
    const legacyValue = localStorageRef.getItem(key);

    if (!sessionValue && legacyValue) {
      sessionStorageRef.setItem(key, legacyValue);
      localStorageRef.removeItem(key);
    }
  });
}

function getAuthValue(key) {
  migrateLegacyAuthStorage();
  return getStorage('sessionStorage')?.getItem(key) ?? null;
}

export function getAccessToken() {
  return getAuthValue(AUTH_KEYS.accessToken);
}

export function getRefreshToken() {
  return getAuthValue(AUTH_KEYS.refreshToken);
}

export function getStoredUsername() {
  return getAuthValue(AUTH_KEYS.username);
}

export function hasAuthSession() {
  return Boolean(getAccessToken());
}

export function setAuthSession({ accessToken, refreshToken, username }) {
  const sessionStorageRef = getStorage('sessionStorage');
  const localStorageRef = getStorage('localStorage');

  if (!sessionStorageRef) {
    return;
  }

  sessionStorageRef.setItem(AUTH_KEYS.accessToken, accessToken);
  sessionStorageRef.setItem(AUTH_KEYS.refreshToken, refreshToken);

  if (username) {
    sessionStorageRef.setItem(AUTH_KEYS.username, username);
  } else {
    sessionStorageRef.removeItem(AUTH_KEYS.username);
  }

  localStorageRef?.removeItem(AUTH_KEYS.accessToken);
  localStorageRef?.removeItem(AUTH_KEYS.refreshToken);
  localStorageRef?.removeItem(AUTH_KEYS.username);
}

export function clearAuthSession() {
  const sessionStorageRef = getStorage('sessionStorage');
  const localStorageRef = getStorage('localStorage');

  Object.values(AUTH_KEYS).forEach((key) => {
    sessionStorageRef?.removeItem(key);
    localStorageRef?.removeItem(key);
  });
}
